import { defineStore } from "pinia"

type AppState = {
   leftDrawerOpen: boolean
}

export const useAppState = defineStore("appState", {
   state: (): AppState => {
      return {
         leftDrawerOpen: false,
      }
   },
   persist: true,
})
